module.exports = {
    AUTH_REQUIRED               : 1,
    
    INVALID_MESSAGE_FORMAT      : 101,
    INVALID_REQ                 : 102,
    INVALID_FIELD_TYPE          : 103,
    INVALID_FIELD_VALUE         : 104,

    MISSING_FIELD_REQ           : 201,
    MISSING_REQUIRED_FIELD      : 250,

    BUSY                        : 400,

    AUTH_FAILED                 : 500,
    INVALID_PARAM_ID            : 501
}